<template>
    <div>
        <div>
            <h3>I. Kết quả KPI</h3>
        </div>
        <div class="mb-1">
            <el-button class="sum-result-v1 mb-2 text-white" style="background-color: rgb(93, 4, 176); border-radius: 8px; padding: 12px">
                % KPI tổng: {{
                    dataPersonal.total_percent_kra >= 0 && dataPersonal.total_percent_kra !== null ? dataPersonal.total_percent_kra + '%' : 'Chưa có'
                }}
            </el-button>
        </div>
        <div style="overflow: scroll; max-height: 500px; min-height: 134px">
            <div class="example-preview table-responsive">
                <div class="table-container">
                    <table class="table table-vertical-center table-bordered" element-loading-text="Loading...">
                        <thead>
                        <tr style="word-break: break-word">
                            <th class="bg-header__table" style="width:15%">KRAs</th>
                            <th class="bg-header__table" style="width:12%">Yêu cầu thành phẩm</th>
                            <th class="bg-header__table" style="width:17%">Thành phẩm</th>
                            <th class="bg-header__table" style="width:5%">Trọng số</th>
                            <th class="bg-header__table" v-for="(item, index) in dataPersonal.details?.[0]?.kra_manager_weeks || []" :key="item.id"
                                style="width:5%">Kết quả tuần
                                {{ index + 1 }}
                            </th>
                            <th class="bg-header__table" style="width:5%">Kết quả KRA</th>
                            <th class="bg-header__table" style="width:20%">Nhận xét</th>
                        </tr>
                        </thead>
                        <tbody v-if="dataPersonal">
                        <tr v-for="item in dataPersonal.details" :key="item.id + item.kra_id" id="teamleadKpi">
                            <td class="text-break kra-content-cell">
                                <div v-if="isEditingContent(item, 'name')" class="kra-edit-content">
                                    <el-input
                                        v-model="editingContentValue"
                                        :disabled="isSavingContent(item)"
                                        type="text"
                                        placeholder="Nhập KRA"
                                        @keyup.enter.native="saveContentField(item, 'name')"
                                    />
                                    <el-tooltip content="Đóng" placement="top">
                                        <el-button
                                            icon="el-icon-close"
                                            size="mini"
                                            circle
                                            :disabled="isSavingContent(item)"
                                            @click="closeContentInput"
                                            @dblclick.native.stop.prevent
                                        />
                                    </el-tooltip>
                                    <el-tooltip content="Lưu" placement="top">
                                        <el-button
                                            icon="el-icon-check"
                                            type="success"
                                            size="mini"
                                            circle
                                            :loading="isSavingContent(item)"
                                            :disabled="isSavingContent(item)"
                                            @click="saveContentField(item, 'name')"
                                            @dblclick.native.stop.prevent
                                        />
                                    </el-tooltip>
                                </div>
                                <div v-else-if="hasText(item.name)" class="kra-view-content">
                                    <el-tooltip effect="dark" :content="plainText(item.name)" placement="top">
                                        <div class="kra-truncate-content">{{ plainText(item.name) }}</div>
                                    </el-tooltip>
                                    <el-popover placement="top-start" width="360" trigger="click">
                                        <div class="kra-popover-content">{{ plainText(item.name) }}</div>
                                        <el-button slot="reference" icon="el-icon-info" size="mini" circle title="Xem đầy đủ nội dung"></el-button>
                                    </el-popover>
                                </div>
                                <el-button
                                    v-else
                                    icon="el-icon-plus"
                                    size="mini"
                                    circle
                                    :disabled="+item.month !== currentMonth || isSavingContent(item)"
                                    @click="openContentInput(item, 'name')"
                                    @dblclick.native.stop.prevent
                                />
                            </td>
                            <td class="line_hieght_table text-break kra-content-cell">
                                <div v-if="isEditingContent(item, 'request_result')" class="kra-edit-content">
                                    <el-input
                                        v-model="editingContentValue"
                                        :disabled="isSavingContent(item)"
                                        type="text"
                                        placeholder="Nhập thành phẩm"
                                        @keyup.enter.native="saveContentField(item, 'request_result')"
                                    />
                                    <el-tooltip content="Đóng" placement="top">
                                        <el-button
                                            icon="el-icon-close"
                                            size="mini"
                                            circle
                                            :disabled="isSavingContent(item)"
                                            @click="closeContentInput"
                                            @dblclick.native.stop.prevent
                                        />
                                    </el-tooltip>
                                    <el-tooltip content="Lưu" placement="top">
                                        <el-button
                                            icon="el-icon-check"
                                            type="success"
                                            size="mini"
                                            circle
                                            :loading="isSavingContent(item)"
                                            :disabled="isSavingContent(item)"
                                            @click="saveContentField(item, 'request_result')"
                                            @dblclick.native.stop.prevent
                                        />
                                    </el-tooltip>
                                </div>
                                <div v-else-if="hasText(item.request_result)" class="kra-view-content">
                                    <el-tooltip effect="dark" :content="plainText(item.request_result)" placement="top">
                                        <div class="kra-truncate-content">{{ plainText(item.request_result) }}</div>
                                    </el-tooltip>
                                    <el-popover placement="top-start" width="360" trigger="click">
                                        <div class="kra-popover-content">{{ plainText(item.request_result) }}</div>
                                        <el-button slot="reference" icon="el-icon-info" size="mini" circle title="Xem đầy đủ nội dung"></el-button>
                                    </el-popover>
                                </div>
                                <el-button
                                    v-else
                                    icon="el-icon-plus"
                                    size="mini"
                                    circle
                                    :disabled="+item.month !== currentMonth || isSavingContent(item)"
                                    @click="openContentInput(item, 'request_result')"
                                    @dblclick.native.stop.prevent
                                />
                            </td>
                            <td class="line_hieght_table text-break kra-content-cell" id="result">
                                <div v-if="hasText(item.results)" class="kra-view-content">
                                    <el-tooltip effect="dark" :content="plainText(item.results)" placement="top">
                                        <div class="kra-truncate-content" v-html="item.results"></div>
                                    </el-tooltip>
                                    <el-tooltip v-if="getFirstLink(item.results)" content="Mở liên kết" placement="top">
                                        <el-button
                                            icon="el-icon-link"
                                            size="mini"
                                            circle
                                            @click="openResultLink(item.results)"
                                            @dblclick.native.stop.prevent
                                        />
                                    </el-tooltip>
                                    <el-popover placement="top-start" width="420" trigger="click">
                                        <div class="kra-popover-content" v-html="item.results"></div>
                                        <el-button slot="reference" icon="el-icon-info" size="mini" circle title="Xem đầy đủ nội dung"></el-button>
                                    </el-popover>
                                </div>
                                <span v-else class="text-muted">Chưa có</span>
                            </td>
                            <td class="line_hieght_table" id="weight" style="font-size: 15px; padding-left: 0 !important; padding-right: 0 !important;">
                                <el-input type="text" :value="`${item?.percent_score}%`" placeholder="Nhập trọng số"/>
                            </td>
                            <td v-for="week in item?.kra_manager_weeks" :key="week.week">
                                <div style="position:relative;">
                                    <el-select
                                        v-model="week.percent_results"
                                        filterable
                                        :class="changeColor(week?.percent_results)"
                                        :disabled="is_disable || !item.results"
                                        :title="!item.results ? 'Không thể chấm do chưa có thành phẩm' : ''"
                                        class="input_percent border-0"
                                        placeholder="Chọn" default-first-option
                                        @change="handleMarkResultKpi(item, week, item?.kra_manager_weeks)"
                                    >
                                        <el-option
                                            v-for="percent in percents"
                                            :key="percent.count"
                                            :label="percent.value + '%'"
                                            :value="percent.count"
                                        >
                                        </el-option>
                                        <div style="margin: 0 10px !important;">
                                            <el-input
                                                v-model="customValue"
                                                placeholder="% khác"
                                                size="small"
                                                @change="addCustomValue(item, week)"
                                            />
                                        </div>
                                    </el-select>
                                    <div v-show="weekSelected?.week === week?.week && kraSelected?.id === item?.id && isShowPopup"
                                         ref="popup"
                                         class="popup-suggest">
                                        <div style="font-weight: 700; display: flex;">Tự động điền</div>
                                        <div style="word-break: break-word; white-space: nowrap">Chấm các tuần còn lại của KRA này là {{ percent }}%?
                                        </div>
                                        <div style="display: flex; justify-content: center; align-items: center; gap: 10px">
                                            <i class="el-icon-circle-check"
                                               style="color: #0C9200; cursor: pointer; font-size: 25px;"
                                               @click="setAllValue"></i>
                                            <i class="el-icon-circle-close"
                                               style="color: red; cursor: pointer; font-size: 25px;"
                                               @click="isShowPopup = false"></i>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td style="text-align: start" id="result-kra">
                                <el-input type="text" :value="(item?.percent_results || item?.percent_results === 0) ? `${item?.percent_results}%` : 'Chưa có'" placeholder=""/>
                            </td>
                            <td>
                                <span
                                    v-if="showWarningComment(item)"
                                    class="text-warning"
                                    style="font-weight: bold">
                                    Hãy giúp nhân sự của bạn biết vì sao họ chưa đạt 100%và gợi ý cách họ có thể cải thiện tốt hơn"
                                </span>
                                <el-input id="input-comment" v-model="item.description" :disabled="is_disable || !item.results"
                                          clearable maxlength="200"
                                          placeholder="Nhập nhận xét..." style="border: 0;">
                                </el-input>
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr class="text-center">
                            <td colspan="10">Không có dữ liệu</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {TEAM_LEAD_UPDATE_KRA} from "@/core/services/store/kpi/kpi.module";
import moment from "moment-timezone";

export default {
    components: {},
    props: {
        dataPersonal: {
            type: Object,
        },
        is_disable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            page: 1,
            percents: [
                {count: 0, value: 0},
                {count: 30, value: 30},
                {count: 60, value: 60},
                {count: 90, value: 90},
                {count: 100, value: 100},
            ],
            customValue: null,
            listWeekly: [],
            weekSelected: null,
            kraSelected: null,
            percent: null,
            isShowPopup: false,
            currentMonth: 1,
            editingContentKey: null,
            editingContentValue: '',
            savingContentKeys: {},
        };
    },
    watch: {
        kraSelected: {
            handler(val) {
                this.calculatorTotalPercent(val)
            },
            deep: true,
        }
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
        this.currentMonth = Number(moment().format('M'));
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        showWarningComment(kra) {
            if (+kra?.percent_results < 100 && (kra.description || '').trim().length === 0 && kra?.kra_manager_weeks?.find(item => this.hasValue(item.percent_results))) {
                return true
            }
        },
        hasValue(value) {
            return value !== null && value !== undefined
        },
        hasText(value) {
            return this.plainText(value).trim().length > 0
        },
        plainText(value) {
            if (!this.hasValue(value)) {
                return ''
            }

            const text = String(value)
            if (!/<[^>]+>/g.test(text)) {
                return text
            }

            const element = document.createElement('div')
            element.innerHTML = text
            return element.textContent || element.innerText || ''
        },
        getContentKey(kra, field) {
            return `${kra.id || kra.kra_id}-${field}`
        },
        isEditingContent(kra, field) {
            return this.editingContentKey === this.getContentKey(kra, field)
        },
        isSavingContent(kra) {
            return Boolean(this.savingContentKeys[kra.id || kra.kra_id])
        },
        openContentInput(kra, field) {
            if (+kra.month !== this.currentMonth || this.isSavingContent(kra)) {
                return
            }

            this.editingContentKey = this.getContentKey(kra, field)
            this.editingContentValue = kra[field] || ''
        },
        closeContentInput() {
            this.editingContentKey = null
            this.editingContentValue = ''
        },
        saveContentField(kra, field) {
            const savingKey = kra.id || kra.kra_id
            if (this.savingContentKeys[savingKey]) {
                return
            }

            this.$set(this.savingContentKeys, savingKey, true)
            const oldValue = kra[field]
            this.$set(kra, field, this.editingContentValue)

            this.handleUpdateKra(kra).then((success) => {
                if (success) {
                    this.closeContentInput()
                } else {
                    this.$set(kra, field, oldValue)
                }
            }).finally(() => {
                this.$delete(this.savingContentKeys, savingKey)
            })
        },
        getFirstLink(value) {
            const html = this.hasValue(value) ? String(value) : ''
            const hrefMatch = html.match(/href=["'](https?:\/\/[^"']+)["']/i)
            if (hrefMatch) {
                return hrefMatch[1]
            }

            const text = this.plainText(value)
            const match = text.match(/https?:\/\/[^\s"'<>]+/i)
            return match ? match[0] : ''
        },
        openResultLink(value) {
            const link = this.getFirstLink(value)
            if (link) {
                window.open(link, '_blank')
            }
        },
        handleClickOutside(event) {
            if (!this.isShowPopup) {
                return
            }

            const target = event.target
            if (
                target?.closest?.('.popup-suggest') ||
                target?.closest?.('.el-select-dropdown') ||
                target?.closest?.('.el-select')
            ) {
                return
            }

            this.isShowPopup = false
        },
        addCustomValue(kra, week) {
            const parsed = typeof this.customValue === 'string' ? parseFloat(this.customValue) : this.customValue
            if (isNaN(parsed)) return
            const normalized = Math.max(0, Math.min(100, parsed))

            week.percent_results = normalized

            this.kraSelected = kra
            this.weekSelected = week
            this.percent = normalized

            this.handleMarkResultKpi(kra, week, kra.kra_manager_weeks)

            const exists = this.percents.some(p => +p.count === +normalized)
            if (!exists) {
                this.percents.push({ count: normalized, value: normalized })
            }
            this.customValue = null
        },
        handleUpdateKra(kra) {
            const payload = {
                id: kra.id,
                name : kra.name,
                request_result: kra.request_result
            }
            return this.$store.dispatch(TEAM_LEAD_UPDATE_KRA, payload).then(res => {
                if (!res.error) {
                    this.$message.success(`Cập nhật kra ${kra.name} thành công !`)
                    return true
                }
                return false
            }).catch(e => {
                console.log(e)
                return false
            })
        },
        changeColor(count) {
            if (+count === 0) {
                return 'kra-text-red';
            } else if (+count >= 30 && +count < 100) {
                return 'kra-text-blue';
            } else if (+count === 100) {
                return 'kra-text-green';
            }else {
                return 'kra-text-black';
            }
        },
        roundDecimal(value, decimals) {
            if (value % 1 !== 0) {
                return parseFloat(value.toFixed(decimals));
            }
            return value;
        },
        setAllValue() {
            if (this.listWeekly?.length && this.hasValue(this.percent)) {
                this.listWeekly.forEach((week) => {
                    week.percent_results = this.percent
                })

                this.calculatorTotalPercent(this.kraSelected)

                this.$nextTick(() => {
                    this.$forceUpdate()
                })
            }
            this.isShowPopup = false
        },
        calculatorTotalPercent(kra) {
            if (!kra) return

            let totalPercent = 0
            let lengthMarked = 0
            let totalPercentUser = 0
            kra?.kra_manager_weeks.map(item => {
                if (this.hasValue(item?.percent_results)) {
                    totalPercent += item?.percent_results
                    lengthMarked += 1
                }
            })
            kra.percent_results = lengthMarked > 0 ? this.roundDecimal((totalPercent / lengthMarked), 2) : null
            this.dataPersonal.details.map(item => {
                if (this.hasValue(item?.percent_results)) {
                    totalPercentUser += (item?.percent_results * item?.percent_score) / 100
                }
            })
            // eslint-disable-next-line vue/no-mutating-props
            this.dataPersonal.total_percent_kra = this.roundDecimal(totalPercentUser, 2)
        },
        handleMarkResultKpi(kra, week, weeks) {
            this.weekSelected = week
            const firstWeekValue = weeks?.[0]?.percent_results
            const shouldSuggestFill =
                (week.week === 1 && this.hasValue(week.percent_results)) ||
                (week.week === 2 && this.hasValue(week.percent_results) && week.percent_results === firstWeekValue)

            if (shouldSuggestFill) {
                this.kraSelected = kra
                this.isShowPopup = true
                this.percent = firstWeekValue
                this.listWeekly = weeks
            } else if (!this.hasValue(weeks?.[0]?.percent_results) && !this.hasValue(weeks?.[1]?.percent_results)) {
                this.isShowPopup = false
            }
            this.calculatorTotalPercent(kra)
        },
    },

};
</script>

<style>
input#input-comment {
    border: 0;
}

.kra-content-cell {
    min-width: 180px;
    vertical-align: top;
}

.kra-view-content {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    width: 100%;
}

.kra-edit-content {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 240px;
}

.kra-truncate-content {
    display: -webkit-box;
    flex: 1;
    max-width: 100%;
    overflow: hidden;
    line-height: 1.5;
    word-break: break-word;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.kra-truncate-content p {
    margin-bottom: 0;
}

.kra-popover-content {
    max-height: 260px;
    overflow-y: auto;
    color: #000;
    line-height: 1.5;
    word-break: break-word;
    white-space: pre-wrap;
}

.kra-popover-content p {
    margin-bottom: 6px;
}

.kra-view-content .el-button,
.kra-edit-content .el-button {
    flex: 0 0 auto;
}

#result-kra .el-input__inner {
    border: none !important;
}

#result .el-input__inner {
    border: none !important;
}

#weight .el-input__inner {
    border: none !important;
}

.kra-text-black input {
    color: black !important;
}

.bg-header__table {
    background-color: #472F92 !important;
    text-align: start;
    color: white;
}

.kra-text-blue input {
    color: #0000ffc4 !important;
}

.kra-text-red input {
    color: #FF0000 !important;
}

.kra-text-green input {
    color: #006B04 !important;
}

thead th {
    position: sticky;
    top: 0;
    background-color: #f8f8f8;
    z-index: 10;
    text-align: center;
}

.table-container {
    max-height: 400px;
    overflow-y: auto;
}

.line_hieght_table {
    line-height: 1.5;
}

.styled-link {
    color: rgba(0, 102, 255, 1);
}

.styled-link:hover {
    color: rgba(0, 102, 255, 1);
    text-decoration: underline !important;
    cursor: pointer;
}

.popup-suggest {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    position: absolute;
    top: 40px;
    left: 100px;
    min-width: 320px;
    max-width: 360px;
    padding: 10px 20px;
    border-radius: 8px;
    background: white;
    box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    z-index: 99;
}
</style>
